export enum AttachmentType {
  file = 0,
  image = 1,
  video = 2,
  audio = 3,
}

export function translateToAttachmentType(type: string): AttachmentType {
  if (type === "file") return AttachmentType.file;
  if (type === "image") return AttachmentType.image;
  if (type === "video") return AttachmentType.video;
  if (type === "audio") return AttachmentType.audio;
  return AttachmentType.file;
}

export function detectAttachmentType(filename: string): AttachmentType {
  const images = [".png", ".jpg", ".jpeg", ".gif", ".svg"];
  const audios = [".mp3", ".wav", ".m4a", ".aac", ".ogg"];
  const videos = [".mp4", ".mov", ".m4v", ".avi", ".wmv", ".webm"];

  if (!filename) return AttachmentType.file;
  const filenameLower = filename.toLowerCase();
  for (const ext of images) {
    if (filenameLower.endsWith(ext)) return AttachmentType.image;
  }
  for (const ext of audios) {
    if (filenameLower.endsWith(ext)) return AttachmentType.audio;
  }
  for (const ext of videos) {
    if (filenameLower.endsWith(ext)) return AttachmentType.video;
  }
  return AttachmentType.file;
}
